/**
 * User Detail → Sessions.
 *
 * TWO tables, not one. Both answer "what did this person do", and an operator
 * looking for that should not have to know which of our two recording systems
 * caught it — so they share a tab. But they stay separate tables, because the
 * records are not the same kind of thing:
 *
 *   - Session traces come from the student and teacher apps, via
 *     UserActionTracker. Ordered page/screen events with time spent, kept 30
 *     days, and only where the `user_session_trace` gate resolves on.
 *   - Site visits come from the public science site, which is static HTML on a
 *     CDN and posts no traces at all — only beacons, kept 180 days.
 *
 * Merging them would produce a list whose rows mean different things and whose
 * absence means different things. A visitor with no traces and eleven beacons
 * is not "inactive"; that reading is exactly what this tab used to invite.
 *
 * See docs/FeatureDesigns/user-actions.md.
 */

import { UserActionSessionList } from '../../user-actions/UserActionSessionList';
import { SiteActivityPanel } from './SiteActivityPanel';

export function SessionsTab({ userId }: { userId: string }) {
  return (
    <div className="features-section">
      <h3 style={{ fontSize: 15, margin: '0 0 12px 0', color: 'var(--text-primary)' }}>
        App sessions
      </h3>
      <UserActionSessionList userId={userId} />

      <h3 style={{ fontSize: 15, margin: '28px 0 4px 0', color: 'var(--text-primary)' }}>
        Science site visits
      </h3>
      <p style={{ margin: '0 0 12px 0', fontSize: 13, color: 'var(--text-tertiary)' }}>
        zitmus.com records beacons rather than session traces, so these are counted
        separately and kept for 180 days.
      </p>
      <SiteActivityPanel userId={userId} />
    </div>
  );
}
